import {CSSProperties} from "react"
import {
  EventPositions,
  EventTypes,
  IEventCompetitor,
  IMaxOdd,
  IOtherOdds, IProviderCompetition,
  ISport,
  IWidgetBackground
} from "./types"
import {
  generateCdnAssetsUrl,
  slugify
} from "./helpers"
import {
  getMeta,
  WidgetMetaTypes
} from "./widget-meta"

// Function checks if event type Event for 2, or 4 competitors, or Fallback
export const checkEventType = (eventCompetitors: IEventCompetitor[]): EventTypes => {
  let type = EventTypes.event_unknown

  eventCompetitors && eventCompetitors.forEach((eventCompetitor:IEventCompetitor) => {
    if(eventCompetitors.length === 2 && (eventCompetitor.position === EventPositions.away || eventCompetitor.position === EventPositions.home)) {
      // Event Top Banner for 2 competitors, e.g. Football match, Ice Hockey
      type = EventTypes.event_1v1
    } else if(eventCompetitors.length === 4 && (eventCompetitor.position === EventPositions.homeSecond ||
      eventCompetitor.position === EventPositions.awaySecond ||
      eventCompetitor.position === EventPositions.home ||
      eventCompetitor.position === EventPositions.away)) {
      // Event Top Banner Four Competitors for 4 competitors, e.g. Tennis 2*2 players
      type = EventTypes.event_2v2
    } else {
      // Fallback for all the other cases + events with 0 eventCompetitors
      type = EventTypes.event_n_v_n
    }
  })

  return type
}

export const getImageSrc = (sportName: string) => generateCdnAssetsUrl(`/mach-center-banner-background/${slugify(sportName)}.png`)
export const getBannerBackgroundImage = (sportName: string): string => `url(${getImageSrc(sportName)}), url(${getImageSrc('football')})`
export const getBannerSportBackground = (sportId: number, backgrounds: IWidgetBackground[] | null): string | null => {
  let url = null;
  if (backgrounds === null) return url;
  backgrounds.forEach((background: IWidgetBackground) => {
    if (background.sportId === sportId) url = `url(${background.url})`;
  });
  return url;
}

export const getBannerBackground = (sportId: number, sportName: string, promotedProvider: IProviderCompetition | null, backgrounds: IWidgetBackground[] | null): string => {
  if (promotedProvider && promotedProvider.backgroundUrl !== null && promotedProvider.backgroundUrl.length > 0)
    return promotedProvider.backgroundUrl;
  let sportBackground = getBannerSportBackground(sportId, backgrounds);
  return sportBackground ? sportBackground : getBannerBackgroundImage(sportName);
}

export const getBannerBgStyles = (sport: ISport, promotedProvider: IProviderCompetition | null, backgrounds: IWidgetBackground[] | null): CSSProperties => {
  return getMeta(WidgetMetaTypes.matchCenterBannerBgImage) === 'hide_image' ? {
    background: 'var(--siw-mc-tb-banner-bg-color)',
  } : {
    backgroundImage: getBannerBackground(sport.id, sport.name, promotedProvider, backgrounds),
  }
}

// Find Odds func for Competitors Event Top Banner
export const findOdds = (odds: IMaxOdd[], outcome: string, promotedProvider: IProviderCompetition | null): IMaxOdd|null => {
  const oddsItem = odds.find((item) => {
    if (promotedProvider !== null) {
      return item.outcomeName === outcome && item.providerId === promotedProvider.providerId;
    } else {
      return item.outcomeName === outcome;
    }
  })

  return oddsItem ?? null;
}

// findOddsInOtherOddsByPromotedProvider func for Competitors Event Top Banner
export const findOddsInOtherOddsByPromotedProvider = (odds: IMaxOdd[], outcome: string, promotedProvider: IProviderCompetition | null): IOtherOdds | null => {
  const oddsItem = odds.find((item) => item.outcomeName === outcome);

  if (!oddsItem || !promotedProvider) {
    return null;
  }

  let promotedOdds: IOtherOdds | null = null;

  if (promotedProvider) {
    const fallbackOddsItem = odds.find((item) => item.outcomeName === outcome);
    if (fallbackOddsItem) {
      promotedOdds = fallbackOddsItem.otherOdds.find((item) => item.provider && item.provider.id === promotedProvider?.providerId) ?? null;
    }
  }

  return promotedOdds;
}

